<template>
  <div style="width: 100%">
    <div v-if="loading" class="loader"></div>
    <div v-else class="content">
      <div class="flex form-input">
        <label class="label" for="logo">
          <span></span>
        </label>
        <img class="img-layout" :src="imageUrl" />
      </div>
      <div class="flex form-input">
        <label class="label" for="name">
          <span>{{ $t("room.create.type") }}</span>
        </label>
        <div class="div-show-detail">
          {{
            room.type == "speed-dating"
              ? $t("room.create.speed_dating")
              : $t("room.create.dating_tonight")
          }}
        </div>
      </div>
      <div class="flex form-input">
        <label class="label" for="name">
          <span>{{ $t("room.create.name") }}</span>
        </label>
        <div class="div-show-detail">
          {{ room.name }}
        </div>
      </div>
      <div v-show="room.type == 'speed-dating'" class="flex form-input">
        <label class="label" for="password">
          <span>{{ $t("room.create.password") }}</span>
        </label>
        <a-input-password
          v-model="room.password"
          :secureTextEntry="true"
          :placeholder="$t('room.create.password')"
        ></a-input-password>
      </div>
      <div v-show="room.type == 'speed-dating'" class="flex form-input">
        <label class="label" for="date">
          <span>{{ $t("room.create.date") }}</span>
        </label>
        <div class="div-show-detail">
          <span>{{ room.startDate }} ~ {{ room.endDate }}</span>
        </div>
      </div>
      <div v-show="room.type == 'speed-dating'" class="flex form-input">
        <label class="label" for="maxPlayer">
          <span>{{ $t("room.create.max_player") }}</span>
        </label>
        <div class="div-show-detail">
          {{ room.settings ? room.settings.max_player : "" }}
        </div>
      </div>
      <div class="flex form-input">
        <label class="label" for="price">
          <span>{{ $t("room.create.price") }}</span>
        </label>
        <div class="div-show-detail">
          {{ room.price }}
        </div>
      </div>
      <div v-show="room.type == 'speed-dating'" class="flex form-input">
        <label class="label" for="price">
          <span>{{ $t("room.create.cost") }}</span>
        </label>
        <span class="div-show-detail">
          {{ room.cost }}<span class="heart">♥</span>
        </span>
      </div>
      <div v-show="room.type == 'dating-tonight'" class="flex form-input">
        <label class="label" for="cash">
          <span>{{ $t("room.create.cash") }}</span>
        </label>
        <div class="div-show-detail">₫ {{ room.cash }}</div>
      </div>
      <div class="flex form-input">
        <label class="label" for="date">
          <span>{{ $t("room.update.status") }}</span>
        </label>
        <a-radio-group v-model="room.status" @change="handleChangeRoomStatus">
          <a-radio-button :value="0">
            {{ $t("room.update.inactive") }}
          </a-radio-button>
          <a-radio-button :value="1">
            {{ $t("room.update.active") }}
          </a-radio-button>
        </a-radio-group>
      </div>
      <div v-show="room.type == 'speed-dating'" class="flex form-input">
        <a-switch
          :checked-children="$t('room.create.private')"
          :un-checked-children="$t('room.create.public')"
          :default-checked="room.private"
          @change="onChangePrivate"
        />
      </div>
    </div>

    <div class="flex box-btn">
      <a-popconfirm
        title="Are you certain?"
        ok-text="Yes"
        cancel-text="No"
        @confirm="confirmCancel"
        @cancel="sayNo"
      >
        <a-button class="cancel" t>{{ $t("room.create.cancel") }}</a-button>
      </a-popconfirm>
      <a-button :loading="loadbtn" @click="save" type="primary">
        {{ $t("room.create.save") }}
      </a-button>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
import CuiAvatar from "@/components/CleanUIComponents/Avatar";
export default {
  components: {
    CuiAvatar,
  },
  data() {
    return {
      uploading: false,
      loading: false,
      loadbtn: false,
      imageUrl: "",
      arrImages: [],
      room: {
        name: "",
        password: "",
        price: "",
        cash: "",
        type: "speed-dating",
        startDate: helper.filters.formatDate(0, "Y-mm-dd"),
        endDate: helper.filters.formatDate(0, "Y-mm-dd"),
        maxPlayer: "",
        status: "",
      },
    };
  },
  methods: {
    confirmCancel(e) {
      console.log(e);
      this.$router.push("/room");
    },
    sayNo(e) {
      console.log(e);
      this.$message.info("Click on No");
    },
    handleChangeRoomStatus(e) {
      console.log(this.room.status);
    },
    onChangePrivate(checked) {
      this.room.private = checked;
    },
    loadData() {
      try {
        this.loading = true;
        this.api("room?id=" + this.$route.params.id).then((res) => {
          this.room = res;
          this.imageUrl = res.image ? res.image : res.logo;
          this.loading = false;
          delete this.room.password;
          console.log(this.room.status);
          console.log(this.room);
        });
      } catch (error) {
        console.log("error", error);
      }
    },
    async save() {
      let data = {
        id: this.$route.params.id,
        status: this.room.status,
      };
      if (this.room.password && this.room.password.trim() != "") {
        data.password = this.room.password.trim();
      }
      this.api("room/update", this.room).then((res) => {
        this.loadbtn = false;
        if (res && !res.error) {
          this.$notification.success({
          message: "success",
          description:
            "Update success.",
        })
        }
      });
    },
  },
  mounted() {
    console.log("this.$routes.param", this.$route.params.id);
    if (this.$route.params.id) {
      this.loadData();
    }
  },
  mixins: [api, helper],
};
</script>
<style scoped>
.box-btn {
  width: 100%;
  justify-content: flex-end;
  margin-top: 30px;
}
.box-btn button {
  width: 100px;
}
.cancel {
  margin-right: 10px;
}
.form-input {
  margin: 10px 0;
}
.form-input input {
  height: 40px;
}
.label {
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #202224;
  width: 170px;
  margin-right: 15px;
}
.heart {
  color: #dc3545;
}
.div-show-detail {
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  height: 32px;
  padding: 7px 13px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.5;
}
.img-layout {
  border: 4px solid #d2d9e5;
  width: 8.46rem;
  height: 8.46rem;
  background-color: #eef0f4;
  border-color: #b8beca;
  display: inline-block;
  overflow: hidden;
  border-radius: 50%;
}
.ant-radio-group {
  width: 100%;
}
</style>